import * as React from 'react';
import cx from 'classnames';

import Checkbox from 'components/Checkbox';
import { DisabledTooltipLayer } from './SelectFromList';
import EventTracking from 'lib/EventTracking';
// @ts-ignore
import GroupChatAvatar from 'chat_v2/components/GroupChatAvatar';
import MediaObject from 'components/MediaObject';
import Text from 'components/Text';
import { ComposerContext } from './ComposerContext';
import { UIEventContext } from './ComposerContext';

import { ComposerRecipients_composerRecipients_recipients_ComposerRecipientListEntity } from 'chat_v2/components/SplitComposer/queries/__generated__/ComposerRecipients';
import { ComposerDispatchContext } from 'chat_v2/ComposerContext';

type Props = {
  entity: ComposerRecipients_composerRecipients_recipients_ComposerRecipientListEntity;
  recipientIsSelected: boolean;
  disabledCopy?: React.ReactNode;
};

export default class GroupChatRecipientItem extends React.Component<Props> {
  render() {
    const { entity, disabledCopy, recipientIsSelected } = this.props;
    const { content, recipient } = entity;

    const component = (
      <ComposerDispatchContext.Consumer>
        {composerDispatch => (
          <ComposerContext.Consumer>
            {composerContext => {
              const selectionHandler = (event: React.ChangeEvent<HTMLInputElement> | React.MouseEvent) => {
                event.preventDefault();

                EventTracking.trackKey(`announcements.share_to.group_chat.${recipientIsSelected ? 'un' : ''}select.click`, composerContext.getUIEventContext());
                
                if (recipientIsSelected) {
                  composerDispatch({ type: 'removeRecipient', uuid: recipient.uuid });
                } else {
                  composerDispatch({ type: 'addRecipient', entity });
                }
              };
              return (
                <li
                  className={cx('RecipientItem', {
                    'RecipientItem--disabled': !!disabledCopy,
                  })}
                  onClick={selectionHandler}
                  data-test-selector={`split-composer-group-chat-${recipient.uuid}`}>
                  <MediaObject figure="right" center>
                    <MediaObject gutter="small" center>
                      <GroupChatAvatar size="medium" />
                      <div>
                        <Text size="small" element="div" truncate>
                          {content.title}
                        </Text>
                        <Text size="xsmall" element="div" color="graphite">
                          {content.info}
                        </Text>
                      </div>
                    </MediaObject>
                    <Checkbox onChange={selectionHandler} checked={recipientIsSelected} />
                  </MediaObject>
                </li>
              );
            }}
          </ComposerContext.Consumer>
        )}
      </ComposerDispatchContext.Consumer>
    );
    return disabledCopy ? (
      <DisabledTooltipLayer text={disabledCopy}>{component}</DisabledTooltipLayer>
    ) : (
      component
    );
  }
}
